module.exports = __webpack_public_path__ + "static/media/daniel_chang.67bd0e6b.png";